export default "__VITE_ASSET__CYPi3FUc__"